<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-container fluid v-if="sensors != null && sensors.length > 0" class="pa-0">
        <v-row dense align="center" justify="center">
            <template v-for="sensor in sensors" >
                <v-col v-if="sensor.body.enabled" :key="sensor.body.sensorKey"  xs="6" sm="3" md="2" lg="2" xl="2" cols="6">
                    <CurrentValue :sensor="sensor" :readonly="readonly" />
                </v-col>
            </template>
        </v-row>
    </v-container>
</template>

<script>
    import CurrentValue from '@/components/box/SensorCurrentValue';
    export default {
        props: {
            sensors: null,
            readonly: false
        },
        components: {
            CurrentValue
        }
    }
</script>
